import React from 'react';



export default function ErrcEd() {

  return (
    <>
        <h1>РЕШЕТКА «УПРАЗДНИТЬ – СНИЗИТЬ – ПОВЫСИТЬ – СОЗДАТЬ»</h1>
        <p>Решетка «Упразднить – Снизить – Повысить – Создать» - это инструмент, похожий на матрицу. Помогает команде сформировать стратегию, которая предоставит потребителям инновацию ценности при одновременном снижении издержек.</p>
        <img src={`${process.env.PUBLIC_URL}/images/ercc-ru.jpg`} style={{width: 600}}/>
        <p>
          В разделы «упразднить» и «снизить» помещаются факторы, которые обеспечивают незначительную или нулевую выгоду для потребителя. За счет этого вы сокращаете издержки без снижения ценности продукта для потребителя. <br></br>

          В разделы «повысить» и «создать» помещаются те факторы, которые предоставляют значительную ценность для потребителей. Это обеспечивает продукту инновацию ценности.

        </p>

        <p>
          Цель инструмента – разработать варианты стратегий, обеспечивающие как дифференциацию (дивергенцию) и инновацию ценности, так и низкие издержки.
        </p>
        <h3>
          Алгоритм работы:
        </h3>
        <p>
          1. Определите, какие факторы следует упразднить, снизить, повысить и создать.
        </p>

        <p>
          2. Заполните решетку «Упразднить – Снизить – Повысить – Создать» - разместите факторы в соответствующих столбцах.
        </p>


        <h3>
          Правила работы с инструментом:
        </h3>

        <p>
          1. В решетке необходимо перечислять факторы – конкретные действия, позволяющие обеспечить результат и по которым вы сможете оценить издержки. Так, например, вместо упразднения «неудобства» нужно перечислить конкретные действия, которые нужны для устранения неудобства.
        </p>
        <p>
          2. При заполнении разделов «Упразднить», «Снизить» и «Повысить» используйте основные факторы конкуренции из «Стратегической канвы текущего положения дел в отрасли». В разделе «Создать» располагайте новые придуманные вами факторы. Всего может быть от 1 до 5 новых факторов.
        </p>



    </>
  )
}
